import{OPACITY_LEVELS as t}from"../constants";export var getOpacityValueFromLabel=function(r){if(r)return t[r]};